// Rewrites a copied RevoGrid range in place, mapping the Product column's product id to its name
// and the Location column's code to its display value. Scoped to those columns by prop.

import { productById } from './catalog';
import { getLocations } from './locationCatalog';

/**
 * Rewrite copied product ids / location codes to their display values, in place.
 * @param data       the copied range (rows of raw cell values)
 * @param centralProps the prop order of the non-pinned (center) columns, e.g.
 *                     ['product','length','location', ...optional, '__status']
 * @param startCol   the copied range's starting column index into centralProps (range.x)
 */
export function rewriteCopiedData(
  data: unknown[][],
  centralProps: string[],
  startCol: number
): void {
  // displayName is optional; fall back to name (mirrors locationLabel) so a location without a
  // formatted display still rewrites to something readable instead of being left as its raw code.
  const displayByCode = new Map(
    getLocations().map((l) => [l.code, l.displayName ?? l.name])
  );
  for (const row of data) {
    if (!Array.isArray(row)) continue;
    for (let c = 0; c < row.length; c++) {
      const value = String(row[c] ?? '');
      if (!value) continue;
      const prop = centralProps[startCol + c];
      if (prop === 'product') {
        const product = productById(value);
        if (product) row[c] = product.name;
      } else if (prop === 'location') {
        const locDisplay = displayByCode.get(value);
        if (locDisplay) row[c] = locDisplay;
      }
    }
  }
}
